import React from 'react';
import { renderToString } from 'react-dom/server';

import { CommentAltIcon } from '../../../icon/regular';
import {
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class TextInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return TextInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    TextInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.TEXT_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.TEXT_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.TEXT_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<CommentAltIcon style={{ height: 20 }} />),
      title: 'Text overlay',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.text;
  }

  openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_TEXT_INSTRUCTION_MODAL,
      {
        instructionId,
        text: '',
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    this.cancelInstruction = this.cancelInstruction.bind(this);

    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_TEXT_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_TEXT_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default TextInstructionBlock;
